import {Box} from '@primer/react'
import type {EventActor$key} from './__generated__/EventActor.graphql'
import type {EventActorAvatarItemBadge$key} from './__generated__/EventActorAvatarItemBadge.graphql'
import {Ago} from './Ago'
import {EventActor} from './EventActor'
import {EventActorAvatarItemBadge} from './EventActorAvatarItemBadge'

type TimelineRowType = {
  actorAvatar: EventActorAvatarItemBadge$key | null
  actor: EventActor$key | null
  highlighted: boolean
  createdAt: string
  deepLinkUrl: string
  showAgoTimestamp?: boolean
  showActorName?: boolean
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
  children: JSX.Element
  largeAvatar?: boolean
  leadingIcon?: JSX.Element
  leadingIconOnTop?: boolean
  forMajorEvent?: boolean
}

export const TimelineRow = ({
  actorAvatar,
  actor,
  showActorName = true,
  showAgoTimestamp = true,
  highlighted,
  children,
  createdAt,
  deepLinkUrl,
  refAttribute,
  largeAvatar,
  leadingIcon,
  leadingIconOnTop,
  forMajorEvent,
}: TimelineRowType) => {
  return (
    <Box
      sx={{
        marginLeft: largeAvatar ? `14px` : `20px`,
        padding: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: leadingIconOnTop ? 'start' : 'center',
      }}
      ref={highlighted ? refAttribute : null}
    >
      {leadingIcon ? (
        leadingIcon
      ) : (
        <EventActorAvatarItemBadge
          largeAvatar={largeAvatar}
          actor={actorAvatar}
          highlighted={highlighted}
          leadingIconOnTop={leadingIconOnTop}
        />
      )}
      <Box sx={{color: 'fg.subtle', fontSize: '14px', marginLeft: forMajorEvent ? '8px' : '12px'}}>
        {showActorName && <EventActor actor={actor} />}
        {children}
        {showAgoTimestamp && <Ago timestamp={new Date(createdAt)} linkUrl={deepLinkUrl} />}
      </Box>
    </Box>
  )
}

try{ TimelineRow.displayName ||= 'TimelineRow' } catch {}